import { render, staticRenderFns } from "./addNewActivity.vue?vue&type=template&id=0d7d851e&"
import script from "./addNewActivity.vue?vue&type=script&lang=js&"
export * from "./addNewActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports